import Brightcove from "./brightcove.es6";

/**
 * 音声の操作クラス
 * @class
 */
export default class voiceHandler {
    constructor() {
        /**
         * クラスBrightcoveのインスタンス
         * @property {{ id: object }} player
         */
        this.player = {};
        /**
         * 再生されている音声のid
         * @property {{ active: string }} status
         */
        this.status = {
            active: "none",
        };
        this.init();
    }

    init() {
        const videoJses = document.querySelectorAll(".js-special-voice");
        videoJses.forEach((videoJs) => {
            const videoJsIdName = videoJs.getAttribute("id");
            const id = videoJs.getAttribute("data-video-id");
            const btn = document.querySelector(`[data-video-btn="${id}"]`);
            this.player[id] = new Brightcove(
                videoJsIdName,
                this.endPlayer.bind(this)
            );
            btn.addEventListener("click", this.handleplayer.bind(this));
        });
    }

    handleplayer(e) {
        const currentId = e.currentTarget.getAttribute("data-video-btn");
        if (this.status.active === "none") {
            this.startPlayer(currentId, e.currentTarget);
        } else if (this.status.active === currentId) {
            this.stopPlayer(currentId);
        } else if (this.status.active !== currentId) {
            this.stopPlayer(this.status.active);
            this.startPlayer(currentId, e.currentTarget);
        }
    }

    startPlayer(id, btn) {
        btn.classList.add("-playing");
        this.player[id].play();
        this.status.active = id;
    }

    stopPlayer(id) {
        const playedBtn = document.querySelector(`[data-video-btn="${id}"]`);
        playedBtn.classList.remove("-playing");
        this.player[id].pause();
        this.status.active = "none";
    }

    endPlayer() {
        const playedBtn = document.querySelector(
            `[data-video-btn="${this.status.active}"]`
        );
        playedBtn.classList.remove("-playing");
        this.status.active = "none";
    }
}
